import Vue from 'vue';
import MessageBoxComponent from '../../components/message-box/message-box.vue';


const prefixCls = 'nio-message-box';
let MessageBoxInstance;
const MessageBox = properties => {
  const _props = properties || {};

  MessageBoxInstance = new Vue({
    data() {
      return Object.assign({}, {
        visible: false,
        width: 416,
        title: '',
        content: '',
        iconType: '',
        iconName: '',
        okText: undefined,
        cancelText: undefined,
        showCancel: false,
        loading: false,
        buttonLoading: false,
        scrollable: false,
        closable: false
      }, _props,)
    },
    render(h) {
      let body_render;
      if (this.render) {
        body_render = h('div', {
          class: `${prefixCls}-body-render ${prefixCls}-body-render-content`
        }, [this.render(h)]);
      } else {
        body_render = h('div', {
          class: this.bodyRenderCls
        }, [
          h('div', {
            class: this.iconTypeCls
          }, [
            h('i', {
              class: this.iconNameCls
            })
          ]),
          h('div', {
            domProps: {
              innerHTML: this.content
            }
          })
        ])
      }

      return h(MessageBoxComponent, {
        props: {...Object.assign({}, _props)},
        domProps: {
          value: this.visible
        },

        on: {
          input: (status) => {
            console.log(status);
            this.visible = status;
          },
          'on-ok': () => {
            this.ok();
          },
          'on-cancel': () => {
            this.cancel();
          },
          'on-messagebox-hidden': () => {
            console.log('组件隐藏动画完成');
            this.destroy();
          }
        }
      }, [body_render]);


    },
    methods: {
      cancel() {
        this.$children[0].visible = false;
        this.cancelCallback();
      },
      ok() {
        if (!this.loading) {
          this.$children[0].visible = false;
        }
        this.okCallback();
      },
      remove() {
        // this.destroy();
        this.$children[0].visible = false;
      },
      destroy() {
        document.body.removeChild(this.$el);
        this.$destroy();
        this.removeCallback();
        MessageBoxInstance = null;


      },
      okCallback() {
      },
      cancelCallback() {
      },
      removeCallback() {
      }
    },
    mounted() {
      this.$children[0].visible = true;
    },
    computed: {
      bodyRenderCls() {
        return {
          [`${prefixCls}-body-render`]: true,
          [`${prefixCls}-body-render-icon`]: !!this.icon
        }
      },
      iconTypeCls() {
        return [
          `${prefixCls}-body-icon`,
          `${prefixCls}-body-icon-${this.iconType}`
        ];
      },
      iconNameCls() {
        return [
          'nio-icon',
          `nio-icon-${this.iconName}`
        ];
      },
    }


  });
  MessageBoxInstance.$mount();
  document.body.appendChild(MessageBoxInstance.$el);
  // const message-box = MessageBoxInstance.$children[0];
  // message-box.visible = MessageBoxInstance.visible = true;

  if ('onOk' in _props) {

    MessageBoxInstance.okCallback = _props.onOk;
  }

  if ('onCancel' in _props) {
    MessageBoxInstance.cancelCallback = _props.onCancel;
  }
  if ('onRemove' in _props) {
    MessageBoxInstance.removeCallback = _props.onRemove;
  }

  MessageBoxInstance.iconType = _props.icon;
  switch (_props.icon) {
    case 'info':
      MessageBoxInstance.iconName = 'information-circled';
      break;
    case 'success':
      MessageBoxInstance.iconName = 'checkmark-circled';
      break;
    case 'warning':
      MessageBoxInstance.iconName = 'android-alert';
      break;
    case 'error':
      MessageBoxInstance.iconName = 'close-circled';
      break;
    case 'confirm':
      MessageBoxInstance.iconName = 'help-circled';
      break;
  }

  return MessageBoxInstance;


};


MessageBox.remove = () => {
  MessageBoxInstance.remove();
}

MessageBox.info = (properties) => {
  properties.icon = 'info';
  properties.showCancel = false;
  return MessageBox(properties);
}


MessageBox.success = (properties) => {
  properties.icon = 'success';
  properties.showCancel = false;
  return MessageBox(properties);
}


MessageBox.warning = (properties) => {
  properties.icon = 'warning';
  properties.showCancel = false;
  return MessageBox(properties);
}


MessageBox.error = (properties) => {
  properties.icon = 'error';
  properties.showCancel = false;
  return MessageBox(properties);
}


export default MessageBox;



// WEBPACK FOOTER //
// ./src/plugins/message-box/index.js